/* eslint-disable no-inline-comments */
import React, {Component} from 'react';
import _get from 'lodash/get';
import {connect} from 'react-redux';
import HelpfulInformation from '../Shared/HelpfulInformation';
// import NearbyFuneralHomes from '../Shared/NearbyFuneralHomes';
import Advertisement from '../Shared/Advertisement';
import CtaModule from '../Shared/CtaModule';
import './css/Aside.styl';

/* NOTE:
 * The <HelpfulInformation/> and <NearbyFuneralHomes/> components have been commented out in order to make more
 * room for ads while a user is scrolling. These components are commented out rather than removed because it is likely
 * that we will want them turned back on in the future.
 */

export class AsideContents extends Component {
  static propTypes = {
    funeralHome: React.PropTypes.object.isRequired,
    nearbyFuneralHomes: React.PropTypes.array,
    isPlanning: React.PropTypes.bool.isRequired,
  };

  render() {
    const {
      isPlanning,
      funeralHome = {} /* , nearbyFuneralHomes = {} */,
    } = this.props;
    const {isPremium} = funeralHome;
    const CtaModuleExists =
      typeof window !== 'undefined' &&
      document.querySelector('.help-planning-question, .FuneralGuideForm') !==
        null;
    const displayAds =
      typeof window !== 'undefined' &&
      window.matchMedia('(min-width: 900px)').matches;
    const displayAdsRightRail =
      typeof window !== 'undefined' &&
      window.matchMedia('(min-width: 900px) and (min-height: 880px)').matches;

    if (isPremium) {
      return (
        <div className="aside-contents">
          <CtaModule />
          <HelpfulInformation />
        </div>
      );
    }

    if (isPlanning) {
      return (
        <div className="aside-contents">
          <CtaModule />
          {/* <HelpfulInformation/> */}
          {displayAds && <Advertisement positionId="display-right-inview-2" />}
          {/* <NearbyFuneralHomes funeralHomes={nearbyFuneralHomes}/> */}
        </div>
      );
    }

    return (
      <div className="aside-contents">
        <CtaModule />
        {displayAds && <Advertisement positionId="display-right-inview-1" />}
        {/* <NearbyFuneralHomes funeralHomes={nearbyFuneralHomes}/> */}
        {!CtaModuleExists && displayAds && (
          <Advertisement positionId="display-right-inview-2" />
        )}
        {CtaModuleExists && displayAdsRightRail && (
          <Advertisement positionId="display-right-inview-2" />
        )}
        {/* <HelpfulInformation/> */}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  page: _get(state, 'obituaryStore.page'),
  funeralHome: state.funeralHomeStore,
  // nearbyFuneralHomes: state.nearbyFuneralHomesStore,
  isPlanning: state.planningStore.isPlanning,
});

export default connect(mapStateToProps)(AsideContents);



// WEBPACK FOOTER //
// ./src/reactModules/pages/Profile/components/Aside/AsideContents.js